import { IValidator } from "./IValidator";
import { IErrorConfig } from "../../../fields/form-field/config/error.config";
import { AbstractControl, ValidationErrors } from "@angular/forms";

export abstract class AbstractValidator implements IValidator {
    public readonly errors: IErrorConfig;
    public readonly validator: (control: AbstractControl) => ValidationErrors;

    protected constructor(errors: IErrorConfig) {
        this.errors = errors;

        this.validator = this.validate.bind(this);
    }

    public abstract validate(control: AbstractControl): ValidationErrors | null;
}